import { SideBarDef } from "ag-grid-community/dist/lib/entities/sideBar";
import { GridOptions } from "ag-grid-community";
import _ from "lodash";
import { ToolPanels } from "constants/product-collection";
import { format } from "lib/globalize-util";
import { DateCellRenderer } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/date-cell-renderer";
import { SortToolPanel } from "components/product-collection/product-collection-views/product-collection-grid-view/tool-panels";
import { PriceWithStrikethroughCell } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/price-with-strikethrough-cell";
import ProductMenu from "containers/legacy-cart/grid-components/ProductMenu";
import LocationMenu from "containers/legacy-cart/grid-components/LocationMenu";
import { IMAGE_URL_FIELD_NAME } from "helpers/server-rollup";
import { ImageCellRenderer } from "../grid-components/ImageCellRenderer";
import { ProductNameLinkRenderer } from "../grid-components/ProductNameLinkRenderer";
import { SizingViewComponents } from "constants/sizingView";
import { ColDef } from "ag-grid-community/dist/lib/entities/colDef";
import ViewsToolPanel from "../grid-components/ViewsToolPanel";

type SideBarOptions = { usePivotMode?: boolean };

export const getSideBar = (sideBarOptions: SideBarOptions): SideBarDef => ({
    toolPanels: [
        {
            id: ToolPanels.Columns,
            labelDefault: format("Columns"),
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
                suppressSyncLayoutWithGrid: false,
                suppressPivotMode: !sideBarOptions.usePivotMode,
            },
        },
        {
            id: ToolPanels.Filters,
            labelDefault: format("Filters"),
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
            toolPanelParams: {
                suppressSyncLayoutWithGrid: true,
            },
        },
        {
            id: ToolPanels.Sort,
            labelDefault: format("Sort"),
            labelKey: "sortToolPanel",
            iconKey: "sortPanel",
            toolPanel: ToolPanels.Sort,
            toolPanelParams: {
                hideColumnIds: [IMAGE_URL_FIELD_NAME],
            },
        },
        {
            id: ToolPanels.Views,
            labelDefault: format("Views"),
            labelKey: "viewsToolPanel",
            iconKey: "viewsToolPanel",
            toolPanel: ToolPanels.Views,
        },
    ],
});

export const icons = {
    sortPanel: '<span class="ag-icon ag-icon-none"/>',
    viewsToolPanel: '<span class="ag-icon ag-icon-eye"/>',
    pivotPanel: '<span class="ag-icon ag-icon-none"/>',
    valuePanel: '<span class="ag-icon ag-icon-none"/>',
    rowGroupPanel: '<span class="ag-icon ag-icon-none"/>',
    columnDrag: '<span class="ag-icon ag-icon-menu"/>',
    columnGroupOpened: '<span class="ag-icon ag-icon-menu"/>',
};

export const getTemplate = {
    overlayLoadingTemplate: () => `<span class="ag-overlay-loading-center">${format("Loading...")}</span>`,
    overlayNoRowsTemplate: () => `<span>${format("No results found")}</span>`,
};

export const gridComponents = {
    // Cell Renderer
    [SizingViewComponents.ImageRenderer]: ImageCellRenderer,
    [SizingViewComponents.ProductMenu]: ProductMenu,
    [SizingViewComponents.LocationMenu]: LocationMenu,
    [SizingViewComponents.ProductNameRenderer]: ProductNameLinkRenderer,
    [SizingViewComponents.DateCellRenderer]: DateCellRenderer,
    [SizingViewComponents.PriceWithStrikethrough]: PriceWithStrikethroughCell,

    // Tool Panel Component
    [ToolPanels.Sort]: SortToolPanel,
    [ToolPanels.Views]: ViewsToolPanel,
};

export const gridOptions: GridOptions = {
    suppressContextMenu: true,
    onGridColumnsChanged: ({ api }) => api.hideOverlay(),
};

export const defaultColDef: ColDef = {
    keyCreator: ({ value }) => value?.toUpperCase?.() ?? value,
    equals: (a, b) => _.isEqual(a, b),
    sortable: true,
    resizable: true,
    floatingFilter: true,
    enableRowGroup: true,
    enablePivot: true,
    enableValue: true,
};

export const autoGroupColumnDef = {
    pinned: "left",
    lockPosition: true,
    lockVisible: true,
    lockPinned: true,
    headerCheckboxSelection: true,
    cellRendererParams: {
        checkbox: true,
    },
};
